// Function used to decrypt e-mail in href
export const _UnCryptMailto = (s: string): string => {
  let n = 0;
  let r = '';
  for (let i = 0; i < s.length; i++) {
    n = s.charCodeAt(i);
    if (n >= 8364) {
      n = 128;
    }
    r += String.fromCharCode(n - 1);
  }
  return r;
};

export const _linkTo_UnCryptMailto = (s: string): void => {
  window.location.href = _UnCryptMailto(s);
};
